/* @flow */

import { rem } from 'polished';

import { tintDuration } from '@e180/ui/lib/token/animation';
import {
  textColor,
  successColor,
  warningColor,
  errorColor,
  darkSuccessColor,
  darkWarningColor,
  darkErrorColor,
} from '@e180/ui/lib/token/color';
import { black } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    position: 'relative',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    minHeight: 50,
    padding: 8,

    backgroundColor: successColor,
    color: 'inherit',

    fontSize: rem(14, baseFontSize),
    fontStyle: 'italic',
    lineHeight: 18 / 14,
    textAlign: 'center',
    textDecoration: 'none',
    WebkitFontSmoothing: 'antialiased',

    transition: `background-color ${tintDuration}`,

    '&:visited': {
      color: 'inherit',
    },
    '&:hover[href]': {
      backgroundColor: darkSuccessColor,
      color: 'inherit',
    },
    '&:active': {
      color: 'inherit',
    },
  },
  'root-withWarning': {
    backgroundColor: warningColor,

    '&:hover[href]': {
      backgroundColor: darkWarningColor,
    },
  },
  'root-withError': {
    backgroundColor: errorColor,

    '&:hover[href]': {
      backgroundColor: darkErrorColor,
    },
  },
  'root-withMedia': {
    textAlign: 'left',
  },
  'root-isDismissable': {
    paddingLeft: 0,
  },
  dismiss: {
    padding: 8,
    opacity: 0.1,
    fill: black,
  },
  media: {
    marginRight: 8,
  },
  text: {
    flex: 1,
  },
  arrow: {
    fill: textColor,
  },
};
